import { render, staticRenderFns } from "./labels.vue?vue&type=template&id=d5dfe068&scoped=true&"
import script from "./labels.vue?vue&type=script&lang=js&"
export * from "./labels.vue?vue&type=script&lang=js&"
import style0 from "./labels.vue?vue&type=style&index=0&id=d5dfe068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5dfe068",
  null
  
)

export default component.exports